import '../App.css';
import { Link } from 'react-router-dom';

function ProjectCard({ title, description, tech, link, image, imagePosition, type, badge }) {

    if (type === 'contact') {
        return (
            <div className="project-card-shell bg-gradient-to-br from-[#172554] via-[#1e3a8a] to-[#0c4a6e] p-6 flex flex-col justify-center items-center gap-6 text-white">
                <div className="absolute top-3 left-3 w-8 h-8 border-2 border-white/40 rounded"></div>
                <div className="absolute bottom-3 right-3 w-8 h-8 border-2 border-white/40 rounded"></div>

                <div className="relative z-10 flex flex-col items-center justify-center gap-4 text-center">
                    <div className="text-4xl mb-2">✉</div>

                    <h3 className="text-white text-2xl font-bold">Let's work together</h3>
                    <a
                        href="mailto:brillantlukas@gmail.com"
                        className="mt-3 px-5 py-3 bg-white text-slate-900 font-semibold rounded-xl transition-transform duration-200 hover:-translate-y-0.5 flex items-center gap-2"
                    >
                        <span>↗</span>
                        Send Email
                    </a>

                </div>

                <div className="absolute top-1/3 left-1/4 w-12 h-12 bg-white/10 rounded-full blur-xl"></div>
                <div className="absolute bottom-1/4 right-1/3 w-16 h-16 bg-cyan-200/20 rounded-full blur-xl"></div>
            </div>
        );
    }
    // Carte par défaut
    let Wrapper;

    if (!link) {
        Wrapper = ({ children }) => <div className="block w-full h-full group">{children}</div>;
    } else if (link.startsWith("http")) {
        Wrapper = ({ children }) => (
            <a href={link} target="_blank" rel="noreferrer" className="block w-full h-full group">
                {children}
            </a>
        );
    } else {
        Wrapper = ({ children }) => (
            <Link to={link} className="block w-full h-full group">
                {children}
            </Link>
        );
    }

    return (
        <div className="project-card-shell">
            <Wrapper>
                <img
                    src={image}
                    alt={title}
                    style={imagePosition ? { objectPosition: imagePosition } : undefined}
                    className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                />

                {badge && (
                    <span className="absolute top-3 right-3 z-10 flex items-center gap-1.5 bg-emerald-500/90 px-2.5 py-1 rounded-full text-xs font-semibold text-white shadow-lg">
                        <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
                        {badge} ↗
                    </span>
                )}

                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/40 to-transparent flex flex-col justify-end p-4 md:p-5">
                    {title && <h3 className="text-white text-lg md:text-xl font-bold">{title}</h3>}
                    {description && <p className="text-slate-200 text-sm mt-1">{description}</p>}
                    {tech && (
                        <div className="flex flex-wrap gap-2 mt-3">
                            {tech.map((t, idx) => (
                                <span key={idx} className="bg-white/20 backdrop-blur-sm px-2.5 py-1 rounded-full text-xs text-white border border-white/25">
                                    {t}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </Wrapper>
        </div>
    );
}

export default ProjectCard;
